// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2HOE-","containerItemsCenter":"Skeleton_containerItemsCenter__W0NLP"};